import moment from "moment";

export const isSubscribed = (endDate: string, freeEndDate: string) => {
  const now = moment();
  if (now < moment(endDate) || now < moment(freeEndDate)) {
    return true;
  } else {
    return false;
  }
};
